import React, { useState, useEffect } from 'react';

import { Wrapper, InnerWrapper } from './style';

const WebsiteInfo = ({ isActive, isInactive, website }) => {
  const [contentEl, setContentEl] = useState();
  const [contentHeight, setContentHeight] = useState();

  const handleWindowResize = () => {
    if (!contentEl) return;
    setContentHeight(contentEl.getBoundingClientRect().height);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });

  return (
    <Wrapper
      isActive={isActive}
      isInactive={isInactive}
      style={{ height: isActive ? contentHeight : 0 }}
    >
      <InnerWrapper
        isActive={isActive}
        ref={el => {
          if (el && !contentEl) {
            setContentEl(el);
            setContentHeight(el.getBoundingClientRect().height);
          }
        }}
      >
        <h3>{website.year}</h3>
        <h2>{website.title}</h2>
        {website.description ? (
          <div
            dangerouslySetInnerHTML={{
              __html: website.description.childMarkdownRemark.html,
            }}
          />
        ) : null}
        {website.credits && website.credits.length > 0 ? (
          <>
            <h3>Credits</h3>
            <ul>
              {website.credits.map((credit, index) => (
                <li key={index}>{credit}</li>
              ))}
            </ul>
          </>
        ) : null}
      </InnerWrapper>
    </Wrapper>
  );
};

export default WebsiteInfo;
